/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout"
import Login from "./Login";
import Registration from "./Registration";
import BusinessRegistration from "../../Registration/BusinessRegistration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/login-3.scss";
import SocialAuth from "./SocialAuth";
import WeChatAuth from "./WeChatAuth";
import { Route } from 'react-router-dom';
import { useLang, setLanguage } from "./../../../../_metronic/i18n/Metronici18n";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";

export function AuthPage() {
  var lang = useLang();
  var intl = useIntl();
  useEffect(() => {
    if (!lang || lang === 'en') {
      var browserLang = window.navigator.userLanguage || window.navigator.language;

      if (browserLang && browserLang.substring(0, 2) !== lang) {
        //let matchLang = languages.find(l => l.lang === browserLang.substring(0,2));
        //if (matchLang) setLanguage(browserLang.substring(0,2));
        setLanguage(browserLang.substring(0, 2));
      }
    }
  }, []);
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"

          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link to="/" className="flex-column-auto mt-5">
                <img
                  alt="Logo"
                  className="max-h-20px"
                  src={toAbsoluteUrl("/media/logos/logo_pnp.png")}
                />
              </Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="login-title flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5">
                  {intl.formatMessage({ id: "PNPLINE_FORWARDING" })}
                </h3>
                <p className="login-desc font-weight-lighter opacity-80">
                  {intl.formatMessage({ id: "PNPLINE_FORWARDING_DESCRIPTION" })}
                </p>
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy; 2021 Pnpline Inc.
                </div>
                {/*<div className="d-flex">
                  <Link to="/terms" className="text-white">
                    Privacy
                    </Link>
                  <Link to="/terms" className="text-white ml-10">
                    Legal
                    </Link>
                  <Link to="/terms" className="text-white ml-10">
                    Contact
                    </Link>
  </div>*/}
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>

          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            
            <ContentRoute path="/auth/registration" component={() => {
              return             <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <span className="font-weight-bold text-dark-50">{intl.formatMessage({ id: "AUTH.HAVE_ACCOUNT" })}</span>
              
              <Link to="/auth/login" className="font-weight-bold ml-2" id="kt_login_signup">{intl.formatMessage({ id: "SIGN_IN" })}</Link>
            </div>
            }} />
            <ContentRoute path="/auth/login" component={() => {
              return <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <span className="font-weight-bold text-dark-50">{intl.formatMessage({ id: "AUTH.GENERAL.NO_ACCOUNT" })}</span>
              
              <Link to="/registration/business-number" className="font-weight-bold ml-2" id="kt_login_signup">{intl.formatMessage({ id: "AUTH.GENERAL.SIGNUP_BUTTON" })}</Link>
            </div>
            }} />

            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <Route path='/auth/google' component={() => {
                  var url = process.env.REACT_APP_OKTA_DOMAIN + "/oauth2/default/v1/authorize"
                    + "?idp=" + process.env.REACT_APP_OKTA_GOOGLE_IDP + "&client_id=" + process.env.REACT_APP_OKTA_CLIENT_ID
                    + "&prompt=login&response_type=id_token&response_mode=fragment&scope=openid" +
                    "&redirect_uri=" + process.env.REACT_APP_OKTA_REDIRECT_URL +
                    "&state=WM6D&nonce=YsG76jo";
                  window.location.href = url;
                  return null;
                }} />
                <Route path='/auth/facebook' component={() => {
                  var url = process.env.REACT_APP_OKTA_DOMAIN + "/oauth2/default/v1/authorize"
                    + "?idp=" + process.env.REACT_APP_OKTA_FACEBOOK_IDP + "&client_id=" + process.env.REACT_APP_OKTA_CLIENT_ID
                    + "&prompt=login&response_type=id_token&response_mode=fragment&scope=openid" +
                    "&redirect_uri=" + process.env.REACT_APP_OKTA_REDIRECT_URL +
                    "&state=WM6D&nonce=YsG76jo";
                  window.location.href = url;
                  return null;
                }} />
                <Route path='/auth/wechat_qr' component={() => {
                  return <iframe className="login-wechat" src={process.env.REACT_APP_WECHAT_AUTH_URL}></iframe>
                }} />
                <Route path="/auth/social" component={SocialAuth} />
                <Route path="/auth/wechat" component={WeChatAuth} />
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute path="/auth/registration" component={Registration} />
                {/* <ContentRoute path="/auth/businessNumberCheck" component={BusinessNumberCheck} /> */}
                {/* <ContentRoute path="/auth/businessRegistration" component={BusinessRegistration} /> */}
                <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />

              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div
              className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; 2021 Pnpline Inc.
              </div>
              {/*<div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/terms" className="text-dark-75 text-hover-primary">
                  Privacy
                  </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Legal
                  </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Contact
                  </Link>
              </div>*/}
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
